<template>
  <div>
    <img src="../../assets/img/homeBG.jpg" style="width: 92%;max-height: 95%"/>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import storageM from '@/storage';

  const storage = storageM['sessionStorage'];

  export default {
    name: 'home',
    created() {
      //标签页首次打开首页，跟出当前库存
      let start = storage.$get({key: 'LOGINANDOPEN',});
      if (!start) {
        setTimeout(v => {
          if (this.userInfor.userType === '0') {
            this.$router.push('/customerService');
          }
          else if (this.userInfor.userType === '1') {
            this.$router.push('/');
          }
        }, 1000);
        storage.$set({key: 'LOGINANDOPEN', parameter: true});
      }
    },
    computed: {
      ...mapGetters({
        userInfor: 'user/userInfor',
      }),
    }
  }
</script>
